import { render, staticRenderFns } from "./CommentFormRead.vue?vue&type=template&id=dba5fb8e&"
import script from "./CommentFormRead.vue?vue&type=script&lang=js&"
export * from "./CommentFormRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports